/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function WebPaymentsWhite(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'WebPaymentsWhite',
      'aria-hidden': true,
      focusable: false,
      width:  35 * scale,
      height: 25 * scale,
      viewBox: '0 0 35 25',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('defs', null,createElement('circle', {"id":"wf-svg-WebPaymentsWhite-__a","cx":"8","cy":"8","r":"8"})),createElement('g', {"fill":"none","fillRule":"evenodd"},createElement('rect', {"width":"35","height":"25","fill":"#FFF","rx":"3.316"}),createElement('g', {"transform":"translate(10 5)"},createElement('mask', {"id":"wf-svg-WebPaymentsWhite-__b","fill":"#fff"},createElement('use', {"xlinkHref":"#wf-svg-WebPaymentsWhite-__a"})),createElement('circle', {"cx":"14","cy":"8","r":"10","stroke":"#3490EB","strokeLinecap":"square","strokeWidth":"2","mask":"url(#wf-svg-WebPaymentsWhite-__b)"}),createElement('circle', {"cx":"2","cy":"8","r":"10","stroke":"#3490EB","strokeLinecap":"square","strokeWidth":"2","mask":"url(#wf-svg-WebPaymentsWhite-__b)"}),createElement('path', {"fill":"#3490EB","mask":"url(#wf-svg-WebPaymentsWhite-__b)","d":"M7 0h2v16H7z"}),createElement('path', {"fill":"#3490EB","mask":"url(#wf-svg-WebPaymentsWhite-__b)","d":"M0 7h16v2H0z"})),createElement('circle', {"cx":"18","cy":"13","r":"8","stroke":"#3490EB","strokeLinecap":"square","strokeWidth":"2"})))
}
